import styled from 'styled-components';
import { HeadingStyle } from 'components/heading';

export const Main = styled.div<{ $isLoading?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 24px;
  text-align: left;

  ${({ $isLoading }) =>
    $isLoading &&
    `
      width: 430px;
      height: 184px;
    `}
`;

export const TextWrapper = styled.div`
  width: 100%;
  max-width: 424px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;

  ${HeadingStyle} {
    text-transform: uppercase;
  }
`;
